(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('fixed-top');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('searchModal');
    }
  }

  customElements.define('sticky-header', StickyHeader);



  var wdtHeaderMenu = document.querySelector('.dt-desktop-menu');
  var wdtDropdowns = wdtHeaderMenu.querySelectorAll('.nav-item');

  let wdtDeviceWidth = window.innerWidth;

  if(wdtDeviceWidth > 1199) {

    wdtDropdowns.forEach(function(wdtItem) {
      var wdtDropdownMenu = wdtItem.querySelectorAll('.dropdown-toggle');

      wdtDropdownMenu.forEach(function(wdt_item) {

          wdt_item.addEventListener('mouseover', function(e) {

            var wdtOverItem = this;
            var dropdownMenu = wdt_item.nextElementSibling;

            dropdownMenu.setAttribute('data-bs-popper', 'static');

            wdtOverItem.classList.add('show');
            dropdownMenu.classList.add('show');
         });

        wdt_item.addEventListener('mouseleave', function(e) {

            var wdtOverItem = this;
            var dropdownMenu = wdt_item.nextElementSibling;

            dropdownMenu.removeAttribute('data-bs-popper', 'static');

            wdtOverItem.classList.remove('show');
            dropdownMenu.classList.remove('show');
         });

        wdt_item.addEventListener('click', function(e) {

            event.preventDefault();
            window.location.href = e.target.href;

         });

      });
    });

  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyr-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  var quizProducts = [];
  try {
    var lyrDataEl = document.getElementById('lyr-quiz-data');
    if (lyrDataEl) { quizProducts = JSON.parse(lyrDataEl.textContent); }
  } catch (e) { quizProducts = []; }

  var vibeQuestions = [
    { q: "Friday night plan?", a: [
        {label:"Rooftop bar, dressed to be seen", vibe:"boujee"},
        {label:"Coffee run then errands, effortless", vibe:"everyday"},
        {label:"Quiet dinner, candlelight, no rush", vibe:"oldmoney"},
        {label:"Out with the group, main character entrance", vibe:"main"}
    ]},
    { q: "Pick a fabric.", a: [
        {label:"Silk slip dress", vibe:"boujee"},
        {label:"Well-fitted denim", vibe:"everyday"},
        {label:"Cashmere & tailoring", vibe:"oldmoney"},
        {label:"Leather jacket", vibe:"main"}
    ]},
    { q: "Your jewelry rule?", a: [
        {label:"More is more", vibe:"boujee"},
        {label:"One piece, worn daily", vibe:"everyday"},
        {label:"Quality over quantity, always", vibe:"oldmoney"},
        {label:"Whatever makes people ask where it's from", vibe:"main"}
    ]},
    { q: "Pick a word for you.", a: [
        {label:"Glamorous", vibe:"boujee"},
        {label:"Reliable", vibe:"everyday"},
        {label:"Refined", vibe:"oldmoney"},
        {label:"Unmissable", vibe:"main"}
    ]}
  ];

  var vibeInfo = {
    boujee:   { title:"Boujee Nights",         blurb:"You dress for the room to notice. Statement pieces, warm gold, zero subtlety, and it works every time." },
    everyday: { title:"Everyday Bold",         blurb:"One good piece, worn on repeat. You don't need noise to feel put-together. Just the right one thing." },
    oldmoney: { title:"Quiet Luxury",          blurb:"Refined, considered, never loud. You'd rather own three pieces you love than ten you don't." },
    main:     { title:"Main Character Energy", blurb:"Unmissable, always. You wear the piece people stop you to ask about." }
  };

  var vqStep = -1;
  var vqScore = { boujee:0, everyday:0, oldmoney:0, main:0 };

  function vqAnswer(vibeKey){
    vqScore[vibeKey]++;
    vqStep++;
    vqRender();
  }

  function vqRestart(){
    vqStep = -1;
    vqScore = { boujee:0, everyday:0, oldmoney:0, main:0 };
    vqRender();
  }

  function vqStart(){ vqStep = 0; vqRender(); }

  function vqRender(){
    var body = document.getElementById('lyrVqBody');
    var bar = document.getElementById('lyrVqProgressBar');
    if(!body) return;

    if(vqStep === -1){
      bar.style.width = '0%';
      body.innerHTML =
        '<div class="lyr-quiz-intro">' +
          '<div class="icon-row">✦ ✦ ✦</div>' +
          '<h3>Find your vibe.</h3>' +
          '<p>Four quick questions. We\'ll tell you which Lyraine edit is actually you, and pull the pieces to match.</p>' +
          '<button class="lyr-btn lyr-btn-primary" onclick="Lyr.vqStart()">Start ✦</button>' +
        '</div>';
      return;
    }

    if(vqStep < vibeQuestions.length){
      bar.style.width = (vqStep / vibeQuestions.length * 100) + '%';
      var item = vibeQuestions[vqStep];
      var optsHtml = item.a.map(function(opt){
        return '<button class="lyr-quiz-option" onclick="Lyr.vqAnswer(\'' + opt.vibe + '\')">' + opt.label + '</button>';
      }).join('');
      body.innerHTML =
        '<div class="lyr-quiz-step-label">Question ' + (vqStep+1) + ' of ' + vibeQuestions.length + '</div>' +
        '<div class="lyr-quiz-question">' + item.q + '</div>' +
        '<div class="lyr-quiz-options">' + optsHtml + '</div>';
      return;
    }

    bar.style.width = '100%';
    var top = Object.keys(vqScore).reduce(function(a,b){ return vqScore[a] >= vqScore[b] ? a : b; });
    var info = vibeInfo[top];
    var recs = quizProducts.filter(function(p){return p.vibe===top;}).slice(0,3);
    if(recs.length < 3){
      var rest = quizProducts.filter(function(p){return p.vibe!==top;});
      recs = recs.concat(rest).slice(0,3);
    }

    var recsHtml = recs.map(function(p){
      return '<div class="lyr-quiz-rec"><a href="' + p.url + '"><img src="' + p.img + '" alt="' + p.name + '"><div class="qr-info"><h5>' + p.name + '</h5><span>' + p.price + '</span></div></a></div>';
    }).join('');

    body.innerHTML =
      '<div class="lyr-quiz-result">' +
        '<div class="badge mixed">' + info.title + '</div>' +
        '<h3>You\'re ' + info.title + '</h3>' +
        '<p class="blurb">' + info.blurb + '</p>' +
        '<div class="lyr-quiz-recs">' + recsHtml + '</div>' +
        '<div class="lyr-quiz-actions">' +
          '<a href="#lyr-bestsellers" class="lyr-btn lyr-btn-coral">Shop My Edit →</a>' +
          '<button class="lyr-btn lyr-btn-outline" onclick="Lyr.vqRestart()">Retake</button>' +
        '</div>' +
      '</div>';
  }

  function initHeroHeadlineReveal(){
    var headline = document.getElementById('lyrHeroHeadline');
    if(!headline) return;
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        headline.classList.add('lyr-animate');
      });
    });
  }

  function initSphereMenu(){
    var stage = document.querySelector('.lyr-sphere-stage');
    var ring = document.getElementById('lyrSphereRing');
    if(!stage || !ring) return;
    var cards = Array.prototype.slice.call(ring.querySelectorAll('.lyr-sphere-card'));
    var count = cards.length;
    if(!count) return;
    var step = 360 / count;
    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var ringAngle = 0;
    var paused = false;
    var dragging = false;
    var currentRadius = 210;
    var resumeTimer = null;
    var lastTs = null;
    var autoDegPerMs = 360 / 44000;
    var hoverIdx = -1;
    var hoverBoost = cards.map(function(){ return 0; });
    var dragState = null;

    function normDeg(a){
      a = a % 360;
      if(a > 180) a -= 360;
      if(a < -180) a += 360;
      return a;
    }

    function updateMetrics(){
      var v = getComputedStyle(stage).getPropertyValue('--sph-radius');
      var n = parseFloat(v);
      if(!isNaN(n)) currentRadius = n;
    }

    function renderSphere(){
      var dipMax = currentRadius * 0.065;
      cards.forEach(function(card, i){
        var eff = normDeg(ringAngle + i * step);
        var rad = eff * Math.PI / 180;
        var s = Math.sin(rad), c = Math.cos(rad);
        var t = (c + 1) / 2;
        var x = s * currentRadius;
        var scale = 0.5 + t * 0.65;
        var opacity = 0.32 + t * 0.68;
        var blur = (1 - t) * 2.2;
        var dip = Math.abs(s) * dipMax;
        var tilt = Math.max(-18, Math.min(18, -eff * 0.18));

        var target = (i === hoverIdx) ? 1 : 0;
        hoverBoost[i] += (target - hoverBoost[i]) * 0.22;
        if(hoverBoost[i] < 0.001) hoverBoost[i] = 0;
        var hb = hoverBoost[i];
        scale = scale * (1 + hb * 0.08);
        dip = dip - hb * 7;
        opacity = Math.min(1, opacity + hb * 0.15);
        blur = blur * (1 - hb);

        var z = Math.round(t * 1000 + hb * 2000);
        card.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + dip.toFixed(2) + 'px,0) rotateY(' + tilt.toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
        card.style.opacity = opacity.toFixed(3);
        card.style.filter = blur > 0.05 ? 'blur(' + blur.toFixed(2) + 'px)' : 'none';
        card.style.zIndex = z;
        card.classList.toggle('is-active', Math.abs(eff) < 6);
      });
    }

    function tick(ts){
      if(lastTs === null) lastTs = ts;
      var dt = ts - lastTs;
      lastTs = ts;
      if(!paused && !dragging){ ringAngle = (ringAngle + autoDegPerMs * dt) % 360; }
      renderSphere();
      requestAnimationFrame(tick);
    }

    function nearestIndex(){
      var raw = -ringAngle / step;
      return ((Math.round(raw) % count) + count) % count;
    }

    function snapToFront(idx, fast){
      if(resumeTimer) clearTimeout(resumeTimer);
      var start = ringAngle;
      var targetRaw = -idx * step;
      var delta = ((targetRaw - start) % 360 + 540) % 360 - 180;
      var end = start + delta;
      if(prefersReduced){
        ringAngle = ((end % 360) + 360) % 360;
        paused = true;
        renderSphere();
        return;
      }
      paused = true;
      var dur = fast ? 500 : 900;
      var startTs = null;
      function easeOutCubic(p){ return 1 - Math.pow(1 - p, 3); }
      function frame(ts){
        if(startTs === null) startTs = ts;
        var p = Math.min((ts - startTs) / dur, 1);
        ringAngle = start + delta * easeOutCubic(p);
        renderSphere();
        if(p < 1){
          requestAnimationFrame(frame);
        } else {
          ringAngle = ((end % 360) + 360) % 360;
          resumeTimer = setTimeout(function(){ paused = false; }, 3000);
        }
      }
      requestAnimationFrame(frame);
    }

    cards.forEach(function(card, i){
      card.dataset.justDragged = '0';
      card.addEventListener('click', function(e){
        if(card.dataset.justDragged === '1'){
          card.dataset.justDragged = '0';
          e.preventDefault();
        }
      });
      if(supportsHover){
        card.addEventListener('pointerenter', function(e){
          if(e.pointerType && e.pointerType !== 'mouse') return;
          hoverIdx = i;
        });
        card.addEventListener('pointerleave', function(e){
          if(e.pointerType && e.pointerType !== 'mouse') return;
          if(hoverIdx === i) hoverIdx = -1;
        });
      }
    });

    function onPointerDown(e){
      if(e.button !== undefined && e.button !== 0) return;
      dragging = true;
      paused = true;
      stage.classList.add('is-dragging');
      dragState = {
        startX: e.clientX,
        startAngle: ringAngle,
        moved: 0,
        pointerId: e.pointerId,
        degPerPx: 180 / (Math.PI * Math.max(currentRadius, 40))
      };
      if(ring.setPointerCapture && e.pointerId !== undefined){
        try { ring.setPointerCapture(e.pointerId); } catch(err){}
      }
    }
    function onPointerMove(e){
      if(!dragging || !dragState) return;
      var dx = e.clientX - dragState.startX;
      dragState.moved = Math.max(dragState.moved, Math.abs(dx));
      ringAngle = dragState.startAngle + dx * dragState.degPerPx;
      renderSphere();
    }
    function onPointerUp(e){
      if(!dragging || !dragState) return;
      dragging = false;
      stage.classList.remove('is-dragging');
      var moved = dragState.moved;
      if(ring.releasePointerCapture && dragState.pointerId !== undefined){
        try { ring.releasePointerCapture(dragState.pointerId); } catch(err){}
      }
      if(moved > 6){
        cards.forEach(function(c){ c.dataset.justDragged = '1'; });
        snapToFront(nearestIndex(), true);
      } else {
        paused = false;
      }
      dragState = null;
    }

    ring.addEventListener('pointerdown', onPointerDown);
    ring.addEventListener('pointermove', onPointerMove);
    ring.addEventListener('pointerup', onPointerUp);
    ring.addEventListener('pointercancel', onPointerUp);

    updateMetrics();
    ring.classList.add('lyr-sphere-ready');
    renderSphere();

    var resizeTimer = null;
    window.addEventListener('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        updateMetrics();
        renderSphere();
      }, 150);
    });

    requestAnimationFrame(tick);
  }

  function initScrollReveal(){
    var items = document.querySelectorAll('.lyr-reveal');
    if(!items.length) return;
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('lyr-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('lyr-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  window.Lyr = {
    vqAnswer: vqAnswer,
    vqRestart: vqRestart,
    vqStart: vqStart
  };

  document.addEventListener('DOMContentLoaded', function(){
    var filterPills = document.querySelectorAll('.lyr-filter-pill');
    filterPills.forEach(function(p){
      p.addEventListener('click', function(){
        filterPills.forEach(function(x){ x.classList.remove('active'); });
        p.classList.add('active');
      });
    });

    vqRender();
    initHeroHeadlineReveal();
    initSphereMenu();
    initScrollReveal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
